export default {
  configure: 'Konfigurieren',
  chat: 'Chat',
  transferToAgent: 'Übertragung an einen Agenten',
  clickToHelpPerson: 'Diese Person braucht Hilfe, klicken Sie, um ihnen zu helfen',
  openConversation: 'Offene Konversation',
  conversations: 'Gespräche',
  noPendingConversations: 'Es sind keine offenen Gespräche',
  lastMessage: 'Letzte Nachricht',
  channel: 'Kanal',
  yourConversations: 'Ihre Gespräche',
  closedConversations: 'Geschlossene Gespräche',
  allConversations: 'Alle Gespräche',
  finishConversation: 'Beenden der Unterhaltung',
  closeChat: 'Schließen Sie den Chat',
  loadingMessages: 'Laden von Nachrichten',
  noMessagesFound: 'Es gibt keine Nachricht',
  conversationAlreadyTaken: 'Konversation bereits geführt',
  toWrite: 'Schreiben',
  toHelp: 'Hilfe',
  attendConversation: 'Teilnahme an Gesprächen',
  quickResponses: 'Schnelle Antworten',
  writeMessage: 'Schreiben einer Nachricht',
  conversationFinishedByAdvisor: 'Gespräch mit Berater beendet',
  finishedConversation: 'Abgeschlossene Konversation',
  conversationTakenByAdvisor: 'Gespräch des Beraters',
  updatedConversation: 'Aktualisierte Unterhaltung',
  configureChat: 'Konfigurieren des Chats',
  loadingConversations: 'Laden von Unterhaltungen',
  waitingForAdvisor: 'Warten auf Berater',
  finished: 'Fertig',
  takenByMe: 'Von mir genommen',
  takenByAdvisor: 'Aufgenommen von der',
  withAdvisor: 'Mit Berater',
  registered: 'Die Person hat noch nicht geschrieben',
  canIHelpYouWithSomething: 'Kann ich Ihnen mit etwas helfen?',
  attachInWebSite: 'Anfügen in Website',
  authenticationType: 'Authentifizierungstyp',
  noAuthentication: 'Ohne Authentifizierung',
  externalAuthentication: 'Externe Authentifizierung',
  form: 'Form',
  city: 'Stadt',
  appearance: 'Aussehen',
  light: 'Licht',
  dark: 'dunkel',
  mainColor: 'Hauptfarbe',
  pickAMainColor: 'Wählen Sie eine Hauptfarbe',
  reestablishColor: 'Wiederherstellung der Farbe',
  backgroundColor: 'Hintergrundfarbe',
  pickABackgroundColor: 'Wählen Sie eine Hintergrundfarbe',
  customLogo: 'Benutzerdefiniertes Logo',
  customTitle: 'Benutzerdefinierter Titel',
  customBubbleMessage: 'Benutzerdefinierte Blasennachricht',
  showEmojis: 'Emojis anzeigen',
  customQuestions: 'Individuelle Fragen',
  insertChatQuestions: 'Geben Sie die Fragen ein, die Sie im Chat anzeigen möchten.',
  permanentMessages: 'Permanente Nachrichten',
  insertFirstChatMessages: 'Geben Sie die Nachrichten ein, die als erste Chatnachricht angezeigt werden sollen.',
  reasonsOfFinishedConversation: 'Gründe für das abgeschlossene Gespräch',
  possibleReasonsAdvisorEndConversation: 'Geben Sie die Hauptgründe ein, warum ein Berater ein Gespräch beenden kann',
  insertQuickResponsesForAdvisors: 'Geben Sie die schnellen Antworten ein, über die Berater verfügen.',
  inactivityMessage: 'Inktivitätsmeldung',
  enableInactivityMessage: 'Inaktivitätsnachricht aktivieren',
  insertInactivityMessage: 'Geben Sie die Inaktivitätsnachricht ein.',
  timeForTriggeringInactivityMessage: 'Zeit in Sekunden zum Auslösen einer Inaktivitätsnachricht',
  attentionSchedule: 'Aufmerksamkeitsplan',
  outOfServiceMessage: 'Out-of-Service-Nachricht',
  customFormMessage: 'Benutzerdefinierte Formularnachricht',
  nonWorkingDay: 'Arbeitstag',
  allDay: 'Den ganzen Tag',
  noOpening: 'Keine Öffnung',
  noClosing: 'Ohne Schließung',
  advisors: 'Berater',
  assignConversationsAutomaticallyToConnectedAdvisors: 'Automatisches Zuweisen von Unterhaltungen zu verbundenen Beratern',
  pickAdvisors: 'Pick Advisors',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  configurationSavedSuccessfully: 'Erfolgreich gespeicherte Einstellungen',
  insertChatInYourWebSite: 'Einfügen eines Chats auf der yor-Website',
  instructionsForInsertingChat: 'Um den Chat in Ihrer Website hinzuzufügen, müssen Sie das nächste Skript in der Fußzeile Ihrer Website hinzufügen.',
  copiedScript: 'Kopiertes Skript',
  errorCopyingScript: 'Fehler beim Kopieren des Skripts',
  noMessage: 'Ohne Nachricht',
  toTransfer: 'Transfer',
  agentSuccessfullyTransferred: 'Agent erfolgreich übertragen',
  youAreDeclaringNoWorkingDay: 'Sie erklären diesen Tag als arbeitsfreien Tag',
  opening: 'Öffnen',
  closing: 'Schließen',
  establishAgentsForSelfAllocationOfConversations: 'Einrichten von Agenten für die Selbstzuweisung von Gesprächen',
  assignConversations: 'Zuweisen von Unterhaltungen',
  ready: 'Bereit',
  advisorUpdated: 'Aktualisierter Berater',
  errorPrecessingRequest: 'Beim Verarbeiten der Anforderung ist ein Fehler aufgetreten.',
  periodStatistics: 'Periodenstatistik',
  noStatsFoundForThisDateRange: 'Für diesen Datumsbereich wurden keine Statistiken gefunden.',
  forEachDayHowMuchWasTheAverageTimePerConversation: 'Wie viel war für jeden Tag die durchschnittliche Zeit pro Gespräch?',
  forEachAdvisorHowMuchWasTheAverageTimePerConversation: 'Wie viel war für jeden Berater die durchschnittliche Zeit pro Gespräch?',
  statsPerDay: 'Statistiken pro Tag',
  noStatsFoundForThisDay: 'Für diesen Tag wurden keine Statistiken gefunden',
  usersCreated: 'Erstellte Benutzer',
  attendedConversations: 'Besuchte Unterhaltungen',
  noAttendedConversations: 'Unbeantwortete Gespräche',
  attendedAndUnansweredConversations: 'Besuchte und unbeaufsichtigte Gespräche',
  attended: 'Besuchte',
  averageTimeBeforeTheAdvisorTookControl: 'Durchschnittliche Zeit, bevor der Berater die Kontrolle übernahm',
  averageTimeSinceTheAdvisorTookControl: 'Durchschnittliche Zeit, seit der Berater die Kontrolle übernimmt',
  howManyWereAttended: 'Wie viele waren dabei?',
  conversationsNumber: 'Anzahl der Unterhaltungen',
  howManyConversationsDidEachAdvisorAttended: 'Wie viele Gespräche hat jeder Berater besucht?',
  numberConversationsAttended: 'Anzahl der besuchten Gespräche',
  howManyUsersWereCreated: 'Wie viele Benutzer wurden erstellt?',
  users: 'Benutzer',
  howLongWasTheAverageTimePerConversation: 'Wie lange war die durchschnittliche Zeit pro Gespräch?',
  minutes: 'Minuten',
  whatWereTheTopicsOfTheConversations: 'Was waren die Themen der Gespräche',
  numberOfRepetitions: 'Anzahl der Wiederholungen',
  howManyConversationsWereAttendedForEachHour: 'Wie viele Gespräche wurden pro Stunde besucht?',
  howManyConversationsDidEachAdvisorHavePerHour: 'Wie viele Gespräche hat jeder Berater pro Stunde geführt?',
  howManyUsersWereCreatedPerHour: 'Wie viele Benutzer wurden pro Stunde erstellt?',
  advisor: 'Berater',
  tellUsWhoYouAre: 'Sagen Sie uns, wer Sie sind',
  selectTheInformationYouWantToAskPeople: ' Wählen Sie die Informationen aus, die Sie personenfragen möchten',
  startConversation: 'Konversation starten',
  emptyMessage: 'Leere Nachricht',
  blockMessageComposer: 'Block-Nachrichten-Komponist',
  timeZone: 'Zeitzone',
  addSchedule: 'Zeitplan hinzufügen',
  checkTheServiceHours: 'Überprüfen Sie die Servicezeiten',
  newKeybeConversation: 'Neues Keybe-Gespräch',
  details: 'Details',
  enterName: 'Name eingeben',
  enterEmail: 'E-Mail eingeben',
  enterPhone: 'Telefon eingeben',
  enterCountry: 'Land eingeben',
  country: 'Land',
  enter: 'Eingeben',
  enterValue: 'Geben Sie den Wert ein',
  selectPerson: 'Wählen Sie eine Person aus',
  anonymousPerson: 'Diese Person ist anonym',
  personDetails: 'Personendaten',
  newApplication: 'Neue Anwendung',
  channels: 'Kanäle',
  authentication: 'Authentifizierung',
  finalization: 'Ende',
  customizeYourConversation: 'Passen Sie Ihre Konversation an',
  schedules: 'Zeitplan',
  assignment: 'Zuordnung',
  correctlyEmailConnection: 'Ihre E-Mail wurde korrekt verbunden',
  correctlyEmailDisconnection: 'Ihre E-Mail wurde erfolgreich getrennt',
  administratorsOnly: 'Nur für Administratoren',
  setTheEndTimeForConversations: 'Legen Sie die Endzeit für Gespräche fest',
  automaticallyEndUnansweredConversations: 'Beenden Sie Konversationen, die nicht mehr beantwortet werden, automatisch',
  definesTheTimeUserStopsResponding: 'Definiert die Zeit zum Beenden der Konversation, sobald der Benutzer nicht mehr antwortet',
  finishAfter: 'Beenden Sie nach',
  enterTheReasonForAutomaticCompletion: 'Geben Sie den Grund für die automatische Fertigstellung ein',
  position: 'Position',
  defaultLanguage: 'Standardsprache',
  tagsAsAMethodOfAutoAssignment: 'Tags als Methode der automatischen Zuweisung',
  enterTags: 'Tags eingeben',
  updateTags: 'Tags aktualisieren',
  communicationChannels: 'Kommunikationskanäle',
  youMustPreviouslyGrantKeybeGooglePermission: 'Sie müssen zuvor Keybe-Berechtigungen erteilen, um auf Ihr Google-Konto zugreifen zu können',
  connectWithGoogle: 'Verbinden Sie sich mit Google',
  youHaveCurrentlyAuthorizedKeybe: 'Sie haben Keybe derzeit autorisiert, auf Ihr Konto zuzugreifen',
  andYouHaveCorrectlyConfiguredGmail: 'und Sie haben Google Mail richtig konfiguriert',
  disconnectFromGmail: 'Trennen Sie die Verbindung zu Google Mail',
  connectToGmail: 'Stellen Sie eine Verbindung zu Google Mail her',
  notifitacionPermissions: 'Sie haben die Berechtigung zum Anzeigen von Benachrichtigungen abgelehnt. Überprüfen Sie die Site-Informationen in der Webadressleiste und lassen Sie Benachrichtigungen weiterhin Benachrichtigungen erhalten, wenn Sie eine Nachricht erhalten',
  dontShowMessage: 'Diese Nachricht nicht mehr anzeigen'
}
